import {TableContainer} from '@mui/material'
import {createContext, ReactNode, useContext} from 'react'
import {FilterModel} from '../../../models/FilterModel'
import {SearchResultModel} from '../../../models/SearchResultModel'
import {useOnChange} from '../../hooks/useOnChange'
import {ControlledFilterTableBaseColumn, TableRowId} from './ControlledFilterTable'

export interface ControlledFilterTableContainerProps<T>
  extends ControlledFilterTableContextValue<T> {
  children?: ReactNode
}

export const ControlledFilterTableContainer = <T extends Record<string, any>>({
  children,
  ...tableProps
}: ControlledFilterTableContainerProps<T>) => {
  useOnChange(tableProps.searchResults, () => {
    tableProps.onSelectedChange?.([])
  })

  return (
    <Context.Provider value={tableProps}>
      <TableContainer>{children}</TableContainer>
    </Context.Provider>
  )
}

export interface ControlledFilterTableContextValue<T> {
  columns: ControlledFilterTableBaseColumn<T>[]
  searchResults?: SearchResultModel<T>
  filters: FilterModel
  selected?: T[]
  onSelectedChange?: (rows: T[]) => void
  idExtractor: (data: T) => TableRowId
  onFilter: (filter: FilterModel) => void
  id?: string
}

const Context = createContext<ControlledFilterTableContextValue<any> | null>(null)

export const useControlledFilterTableContainerProps = <T,>() => {
  const value = useContext(Context)
  if (!value) {
    throw new Error('No provider.')
  }
  return value as ControlledFilterTableContextValue<T>
}
